const drawerProductSlider = () => {
	const slider = document.querySelector(".cart-products__swiper");
	if (!slider) {
		return "";
	}
	const sliderId = slider.dataset.id;

	const swiperParms = {
		keyboard: true,
		loop: true,
		slidesPerView: 1,
		navigation: {
			nextEl: `#${sliderId} .cart-swiper-button-next`,
			prevEl: `#${sliderId} .cart-swiper-button-prev`,
		},
	};
	const swiper = new Swiper(`#${sliderId} .swiper`, swiperParms);
};

document.addEventListener("DOMContentLoaded", function () {
	drawerProductSlider();
	document.addEventListener("shopify:section:load", function () {
		drawerProductSlider();
	});
});

class CartRemoveButton extends HTMLElement {
	constructor() {
		super();

		this.addEventListener("click", (event) => {
			event.preventDefault();
			const cartItems =
				this.closest("cart-items") || this.closest("cart-drawer-items");
			cartItems.updateQuantity(this.dataset.index, 0);
		});
	}
}

customElements.define("cart-remove-button", CartRemoveButton);


class CartItems extends HTMLElement {
	constructor() {
		super();
		this.lineItemStatusElement =
			document.getElementById("shopping-cart-line-item-status") ||
			document.getElementById("CartDrawer-LineItemStatus");

		const debouncedOnChange = debounce((event) => {
			this.onChange(event);
		}, ON_CHANGE_DEBOUNCE_TIMER);

		this.addEventListener("change", debouncedOnChange.bind(this));
	}

	cartUpdateUnsubscriber = undefined;

	connectedCallback() {
		this.cartUpdateUnsubscriber = subscribe(
			PUB_SUB_EVENTS.cartUpdate,
			(event) => {
				if (event.source === "cart-items") {
					return;
				}
				this.onCartUpdate();
			}
		);
		drawerProductSlider();
	}

	disconnectedCallback() {
		if (this.cartUpdateUnsubscriber) {
			this.cartUpdateUnsubscriber();
		}
	}

	onChange(event) {
		this.updateQuantity(
			event.target.dataset.index,
			event.target.value,
			document.activeElement.getAttribute("name")
		);
	}

	onCartUpdate() {
		fetch(`${routes.cart_url}?section_id=main-cart`)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				const sourceQty = html.querySelector("cart-items");
				this.innerHTML = sourceQty.innerHTML;
			})
			.catch((e) => {
				console.error(e);
			});
	}

	getSectionsToRender() {
		return [
			{
				id: "main-cart-items",
				section: document.getElementById("main-cart-items").dataset.id,
				selector: ".js-contents",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
			{
				id: "cart-live-region-text",
				section: "cart-live-region-text",
				selector: ".shopify-section",
			},
			{
				id: "main-cart-footer",
				section: document.getElementById("main-cart-footer").dataset.id,
				selector: ".js-contents-2",
			},
		];
	}

	updateQuantity(line, quantity, name) {
		this.enableLoading(line);
		this.querySelectorAll(".quantity__button").forEach((button) =>
			button.classList.add("disabled")
		);

		const body = JSON.stringify({
			line,
			quantity,
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		});

		fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
			.then((response) => {
				return response.text();
			})
			.then((state) => {
				const parsedState = JSON.parse(state);
				const quantityElement =
					document.getElementById(`Quantity-${line}`) ||
					document.getElementById(`Drawer-quantity-${line}`);
				const items = document.querySelectorAll(".cart-item");
				if (parsedState.errors) {
					quantityElement.value = quantityElement.getAttribute("value");
					this.updateLiveRegions(line, parsedState.errors);
					return;
				}

				this.classList.toggle("is-empty", parsedState.item_count === 0);
				const cartDrawerWrapper = document.querySelector("cart-drawer");
				const cartFooter = document.getElementById("main-cart-footer");

				if (cartFooter)
					cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
				if (cartDrawerWrapper)
					cartDrawerWrapper.classList.toggle(
						"is-empty",
						parsedState.item_count === 0
					);

				this.getSectionsToRender().forEach((section) => {
					const elementToReplace =
						document
							.getElementById(section.id)
							.querySelector(section.selector) ||
						document.getElementById(section.id);
					elementToReplace.innerHTML = this.getSectionInnerHTML(
						parsedState.sections[section.section],
						section.selector
					);
				});
				const updatedValue = parsedState.items[line - 1]
					? parsedState.items[line - 1].quantity
					: undefined;
				let message = "";
				if (
					items.length === parsedState.items.length &&
					updatedValue !== parseInt(quantityElement.value)
				) {
					if (typeof updatedValue === "undefined") {
						message = window.cartStrings.error;
					} else {
						message = window.cartStrings.quantityError.replace(
							"[quantity]",
							updatedValue
						);
					}
				}
				this.updateLiveRegions(line, message);

				const lineItem =
					document.getElementById(`CartItem-${line}`) ||
					document.getElementById(`CartDrawer-Item-${line}`);
				if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
					cartDrawerWrapper
						? trapFocus(
								cartDrawerWrapper,
								lineItem.querySelector(`[name="${name}"]`)
						  )
						: lineItem.querySelector(`[name="${name}"]`).focus();
				} else if (parsedState.item_count === 0 && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper.querySelector(".drawer__inner-empty"),
						cartDrawerWrapper.querySelector("a")
					);
				} else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
					trapFocus(
						cartDrawerWrapper,
						document.querySelector(".cart-item__name")
					);
				}

				

				publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });

				//AK custom code
				const timestamp = lineItem.getAttribute('data-timestamp');
				if(timestamp){
					// setTimeout(function() {
						update_related_item(timestamp,quantity);
					// }, 500);
				}
				//End Ak custom code
			})
			.catch(() => {
				this.querySelectorAll(".loading-overlay").forEach((overlay) =>
					overlay.classList.add("hidden")
				);
				this.querySelectorAll(".quantity__button").forEach((button) =>
					button.classList.remove("disabled")
				);
				const errors =
					document.getElementById("cart-errors") ||
					document.getElementById("CartDrawer-CartErrors");
				errors.textContent = window.cartStrings.error;
			})
			.finally(() => {
				this.querySelectorAll(".quantity__button").forEach((button) =>
					button.classList.remove("disabled")
				);
				this.disableLoading(line);
			});
	}

	updateLiveRegions(line, message) {
		const lineItemError =
			document.getElementById(`Line-item-error-${line}`) ||
			document.getElementById(`CartDrawer-LineItemError-${line}`);
		if (lineItemError)
			lineItemError.querySelector(".cart-item__error-text").innerHTML = message;

		this.lineItemStatusElement.setAttribute("aria-hidden", true);

		const cartStatus =
			document.getElementById("cart-live-region-text") ||
			document.getElementById("CartDrawer-LiveRegionText");
		cartStatus.setAttribute("aria-hidden", false);

		setTimeout(() => {
			cartStatus.setAttribute("aria-hidden", true);
		}, 1000);
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	enableLoading(line) {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems");
		mainCartItems.classList.add("cart__items--disabled");

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`
		);
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`
		);

		[...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
			overlay.classList.remove("hidden")
		);

		document.activeElement.blur();
		this.lineItemStatusElement.setAttribute("aria-hidden", false);
	}

	disableLoading(line) {
		const mainCartItems =
			document.getElementById("main-cart-items") ||
			document.getElementById("CartDrawer-CartItems");
		mainCartItems.classList.remove("cart__items--disabled");

		const cartItemElements = this.querySelectorAll(
			`#CartItem-${line} .loading-overlay`
		);
		const cartDrawerItemElements = this.querySelectorAll(
			`#CartDrawer-Item-${line} .loading-overlay`
		);

		cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
		cartDrawerItemElements.forEach((overlay) =>
			overlay.classList.add("hidden")
		);
	}
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
	customElements.define(
		"cart-note",
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					"input",
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, {
							...fetchConfig(),
							...{ body },
						});
					}, ON_CHANGE_DEBOUNCE_TIMER)
				);
			}
		}
	);
}


// function update_related_item(timestamp,quantity){

// 	const item = document.querySelector(".cart-item[data-timestamp='"+timestamp+"']");
// 	const item_line = parseInt(item.querySelector('.quantity__input').getAttribute('data-index'));

// 	const cartItems = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
// 	const key = item.getAttribute('data-key');

// 	// cartItems.updateQuantity(item_line, quantity);
// 	fetch("/cart/change.js", {
// 		method: "POST",
// 		headers: { "Content-Type": "application/json" },
// 		body: JSON.stringify({
// 			line:item_line,
// 			key: key,
// 			quantity: quantity
// 		}),
// 	});


		// const body = JSON.stringify({
		// 	item_line,
		// 	quantity,
		// 	// sections: this.getSectionsToRender().map((section) => section.section),
		// 	// sections_url: window.location.pathname,
		// });

		// fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
		// 	.then((response) => {
		// 		return response.text();
		// 	})
		// 	.then((state) => {
		// 		const parsedState = JSON.parse(state);
		// 	})

// }


// async function update_related_item(timestamp, quantity) {
// 	const res = await fetch("/cart.js");
// 	const cart = await res.json();

// 	const updates = {};

// 	cart.items.forEach((item) => {
// 		if(!item.properties?._main_product){
// 			// if (item.properties?._timestamp === timestamp) {
// 			if(String(item.properties?._timestamp) === timestamp){
// 				updates[item.key] = quantity;
// 			}
// 		}
// 	});

// 	if (!Object.keys(updates).length) return;

// // 	const response = await fetch("/cart/update.js", {
// //   method: "POST",
// //   headers: { "Content-Type": "application/json" },
// //   body: JSON.stringify({
// //     updates,
// //     sections: [
// //       "cart-drawer",
// //       "cart-drawer-items",
// //       "cart-drawer-footer",
// //       "cart-icon-bubble",
// //       "cart-notification-product",
// //       "cart-notification-button"
// //     ],
// //     sections_url: window.location.pathname
// //   }),
// // });

// // if (!response.ok) {
// //   throw new Error("Cart update failed");
// // }


// // const parsedResponse = await response.json();

// // const new_cart =
// //   document.querySelector("cart-notification") ||
// //   document.querySelector("cart-drawer");

// //   console.log('parsedResponse',parsedResponse);

// // if (new_cart && typeof new_cart.renderContents === "function") {
// //   new_cart.renderContents(parsedResponse);
// // }

// // // keep Dawn in sync
// // publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });


// 	const response = await fetch("/cart/update.js", {
// 		method: "POST",
// 		headers: { "Content-Type": "application/json" },
// 		body: JSON.stringify({ updates }),
// 	});

// 	if (!response.ok) {
// 		throw new Error("Cart update failed");
// 	}

// 	// const cart = await response.json();

// 	// ✅ SUCCESS
// 	// console.log("Cart updated successfully", cart);
// 	console.log('res',response)
// 	// publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-drawer" });
// // document.dispatchEvent(new CustomEvent("cart:updated"));

// 	// const new_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
// 	// new_cart.renderContents(response);
	

// 	// Optional: trigger Dawn refresh
// 	// document.dispatchEvent(
// 	// 	new CustomEvent("cart:updated", { detail: cart })
// 	// );

// 	if (CartDrawer && typeof CartDrawer.renderContents === "function") {
// 	fetch("/cart.js")
// 		.then((res) => res.json())
// 		.then((updatedCart) => {
// 			console.log('hiii')
// 		CartDrawer.renderContents(updatedCart);

// 		// If you ever need item count again:
// 		// const itemCount = document.querySelectorAll(
// 		//   "#CartDrawer-CartItems .cart-items .cart-item"
// 		// ).length;
// 		//
// 		// document.querySelector('.cart-count-bubble [aria-hidden="true"]').textContent = itemCount;
// 		// document.querySelector('.drawer__heading sup').textContent = `(${itemCount})`;
// 		// document.querySelector('.articcles-counts span').textContent = itemCount;
// 		});
// 	}


// }



async function update_related_item(timestamp, quantity) {
  const cartRes = await fetch("/cart.js");
  const cart = await cartRes.json();

  const updates = {};

  cart.items.forEach((item) => {
    if (
      !item.properties?._main_product &&
      String(item.properties?._timestamp) === String(timestamp)
    ) {
      updates[item.key] = quantity;
    }
  });

  if (!Object.keys(updates).length) return;

  const response = await fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      updates,
      sections: ["cart-drawer", "cart-icon-bubble"],
      sections_url: window.location.pathname,
    }),
  });

  if (!response.ok) {
    throw new Error("Cart update failed");
  }

  const parsedState = await response.json();

  const cartDrawer =
    document.querySelector("cart-drawer") ||
    document.querySelector("cart-notification");

  if (cartDrawer && typeof cartDrawer.renderContents === "function") {
    cartDrawer.renderContents(parsedState);
  }

  publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items" });
}

